import React, { Component } from 'react';

class Thanks extends Component {
  componentDidMount() {
    var that = this;
    that.props.clearValues();
  }
  
  render() {

    return (
      <div className="success_page">
        <h2 className="contact">お問い合わせありがとうございます。</h2>
        <div>
          <p>
            <span>お客様のお問合せ内容が送信されました。</span><br />
            <span>お客様が記入されたEメールアドレスに、お問合せ内容確認のメールを送信致しました。</span>
          </p>
        </div>
        <div className="row">
          <div className="btn_box">
            <a className="button" href="/">TOPへ</a>
          </div>
        </div>
      </div>
    );
  }

}

export default Thanks;



// WEBPACK FOOTER //
// ./src/contact/Thanks.js